const o = {
  beaconTagName: "beacon-modal",
  beaconNestedComponents: ["beacon-icon-button"],
  maxiModalColumnBreakpoint: 1216,
  fixedClassName: "fixed",
  actionZonePaddingOffset: 4,
  contentZoneLogoPaddingCSSVar: "--modal-content-zone-logo-padding",
  modalCloseButtonSpacingCSSVar: "--modal-remove-close-button-spacing",
  modalHeaderZIndexCSSVar: "--beacon-modal-header-z-index",
  modalMediaClass: "media-dummy dummy beacon-modal__media",
  modalTitleClass: "beacon-modal__title",
  modalDescriptionClass: "beacon-modal__description",
  DATA_METRICS_LOCATION_MODAL: "PU"
};
export {
  o as C
};
